import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Snackbar from 'material-ui/Snackbar'
import { SHOW_SNACKBAR_TOASTR_HIDE } from '../../actions/loading'

const mapStateToProps = state => ({
  snackbar: state.snackbar
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

class SnackbarToastr extends Component {
  constructor(props) {
    super(props)
    this.handleRequestClose = this.handleRequestClose.bind(this)
  }

  handleRequestClose() {
    this.props.dispatch({
      type: SHOW_SNACKBAR_TOASTR_HIDE
    })
  }

  render() {
    return (
      <div>
        <Snackbar
          open={this.props.snackbar.open}
          message={this.props.snackbar.message || ''}
          action='GOT IT'
          className='snackbar-root'
          autoHideDuration={4000}
          onRequestClose={this.handleRequestClose}
          bodyStyle={{ maxWidth: 'none' }}
        />
      </div>
    )
  }
}

SnackbarToastr.propTypes = {
  snackbar: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(SnackbarToastr)



/** WEBPACK FOOTER **
 ** ./src/components/Common/Snackbar.js
 **/